import { Card, Col, Grid } from "@tremor/react";
import { Statistic } from "antd";

import { type ChatResponseMetricsData } from "../hooks/useChatResponseMetrics";

interface ResponseTimeKPIsProps {
  data: ChatResponseMetricsData | undefined;
  isLoading: boolean;
}

const formatMinutes = (minutes: number | null): string => {
  if (minutes === null) return "-";
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes === 0) return `${hours}h`;
  return `${hours}h ${remainingMinutes}min`;
};

export const ResponseTimeKPIs = ({ data, isLoading }: ResponseTimeKPIsProps) => {
  const totals = data?.totals;

  return (
    <Grid numItemsSm={2} numItemsLg={4} className="gap-4">
      <Col>
        <Card>
          <Statistic
            loading={isLoading}
            title="Średni czas odpowiedzi (godziny pracy)"
            value={formatMinutes(totals?.avgBusinessMinutes ?? null)}
            valueStyle={{
              color: totals?.avgBusinessMinutes
                ? totals.avgBusinessMinutes <= 60
                  ? "#3f8600"
                  : totals.avgBusinessMinutes <= 120
                    ? "#d4b106"
                    : "#cf1322"
                : undefined,
            }}
          />
        </Card>
      </Col>
      <Col>
        <Card>
          <Statistic
            loading={isLoading}
            title="Łączna liczba odpowiedzi"
            value={totals?.totalResponses ?? 0}
            valueStyle={{ color: "#1890ff" }}
          />
        </Card>
      </Col>
      <Col>
        <Card>
          <Statistic
            loading={isLoading}
            title="Wskaźnik przekroczeń"
            value={totals?.breachRate ?? 0}
            suffix="%"
            valueStyle={{
              color: totals?.breachRate
                ? totals.breachRate <= 5
                  ? "#3f8600"
                  : totals.breachRate <= 15
                    ? "#d4b106"
                    : "#cf1322"
                : undefined,
            }}
          />
        </Card>
      </Col>
      <Col>
        <Card>
          <Statistic
            loading={isLoading}
            title="Liczba przekroczeń"
            value={totals?.totalBreached ?? 0}
            valueStyle={{ color: "#cf1322" }}
          />
        </Card>
      </Col>
    </Grid>
  );
};
